export const useStoreHome = defineStore('StoreHome', {
    state: () => ({
        dancers: null,
        error: null,
    }),
    actions: {
        async getHome() {
            await Promise.all([useStoreStreams().getStreams(), this.getDancers()]);
        },
        async getDancers() {
            this.error = null;
            const filter = {
                paginate: {
                    start: 0,
                    limit: 15,
                },
            };
            ({dancers: this.dancers, error: this.error} = await useQueryDancers().get(filter));
        },
    },
});
